@if (isCreate()) {
  <p-toast></p-toast>
  <p-dialog
    [visible]="true"
    (visibleChange)="!$event && closeCreate()"
    [header]="'adminNotifications.createRule' | translate"
    [modal]="true"
    [style]="{ width: '42rem', maxWidth: '95vw' }"
  >
    @if (loading()) {
      <app-loading></app-loading>
    } @else {
      <ng-container *ngTemplateOutlet="ruleForm"></ng-container>
    }
    <ng-template #footer>
      <app-primary-button title="Save" (action)="saveRule()"></app-primary-button>
    </ng-template>
  </p-dialog>
} @else {
<div class="rule-page">
  <p-toast></p-toast>
  <div class="page-header">
    <app-back-button
      [parentRoute]="listPath"
      [title]="isCreate() ? 'adminNotifications.createRule' : (savedRule()?.name || 'adminNotifications.rules')"
      [subtitle]="isCreate() ? null : savedRule()?.eventKey"
    ></app-back-button>
    <div class="header-actions">
      <app-secondary-button
        title="Refresh"
        icon="refresh"
        [disable]="loading()"
        (action)="reload()"
      ></app-secondary-button>
      @if (!isCreate() && !loading() && !missing()) {
        <app-primary-button title="Edit" (action)="beginEdit()"></app-primary-button>
        @if (savedRule()?.isActive) {
          <app-secondary-button title="adminNotifications.pause" (action)="setActive(false)"></app-secondary-button>
        } @else {
          <app-secondary-button title="adminNotifications.resume" (action)="setActive(true)"></app-secondary-button>
        }
        <app-secondary-button title="adminNotifications.test" (action)="openTest()"></app-secondary-button>
        <app-secondary-button title="adminNotifications.delete" (action)="deleteRule()"></app-secondary-button>
      }
      @if (isCreate() && !loading()) {
        <app-primary-button title="Save" (action)="saveRule()"></app-primary-button>
      }
    </div>
  </div>

  @if (loading()) {
    <app-loading></app-loading>
  } @else if (missing()) {
    <div class="empty-state">{{ 'adminNotifications.ruleNotFound' | translate }}</div>
  } @else {
    @if (!isCreate() && ruleId(); as id) {
      <app-copyable-identifier [value]="id"></app-copyable-identifier>
    }
    @if (isCreate()) {
      <ng-container *ngTemplateOutlet="ruleForm"></ng-container>
    }
    @if (!isCreate() && summary(); as row) {
      <dl class="settings rule-summary">
        <dt>{{ 'adminNotifications.name' | translate }}</dt><dd>{{ row.name }}</dd>
        <dt>{{ 'adminNotifications.event' | translate }}</dt>
        <dd>
          @if (row.eventUrl) {
            <a [routerLink]="row.eventUrl">{{ row.eventLabel }}</a>
          } @else {
            {{ row.eventLabel }}
          }
        </dd>
        @if (!row.hideSourceProcess) {
          <dt>{{ 'adminNotifications.sourceProcess' | translate }}</dt>
          <dd>
            @if (row.processUrl) {
              <a [routerLink]="row.processUrl">{{ row.processLabel | translate }}</a>
            } @else {
              {{ row.processLabel | translate }}
            }
          </dd>
        }
        <dt>{{ 'adminNotifications.priority' | translate }}</dt><dd>{{ row.priority | translate }}</dd>
        @if (!row.hideTemplate) {
          <dt>{{ 'adminNotifications.template' | translate }}</dt><dd>{{ row.templateLabel }}</dd>
        }
        <dt>{{ 'adminNotifications.channels' | translate }}</dt><dd>{{ row.channelLabels || '—' }}</dd>
        <dt>{{ 'adminNotifications.active' | translate }}</dt><dd>{{ (row.isActive ? 'Yes' : 'No') | translate }}</dd>
        <dt>{{ 'adminNotifications.recipients' | translate }}</dt>
        <dd>
          @for (recipient of row.recipientLabels; track $index) {
            <div>{{ recipient.kind | translate }}: {{ recipient.value }}</div>
          } @empty { <span>—</span> }
        </dd>
        <dt>{{ 'adminNotifications.escalation' | translate }}</dt>
        <dd>
          @for (step of row.escalationLabels; track $index) {
            <div>{{ 'adminNotifications.afterMinutes' | translate }}: {{ step.afterMinutes }} · {{ step.channels || '—' }} · {{ step.recipients || '—' }}</div>
          } @empty { <span>—</span> }
        </dd>
      </dl>
    }
    @if (!isCreate()) {
      <section class="deliveries-panel orch-table-panel">
        <app-orchestration-table-heading heading="adminNotifications.deliveries" [showSearch]="false">
        </app-orchestration-table-heading>
        <app-data-table
          [columns]="deliveryColumns()"
          [data]="deliveries()"
          [config]="deliveryTableConfig()"
          (onRowClick)="openJournalRow($event)"
        ></app-data-table>
      </section>
    }
  }
</div>

<p-dialog
  [visible]="!!journalDetail()"
  (visibleChange)="onJournalDetailVisibleChange($event)"
  [header]="'adminNotifications.journal' | translate"
  [modal]="true"
  [style]="{ width: '36rem' }"
>
  @if (journalView(); as row) {
    <dl class="settings">
      <dt>{{ 'adminNotifications.event' | translate }}</dt>
      <dd>{{ row.eventKey }}</dd>
      <dt>{{ 'adminNotifications.recipient' | translate }}</dt>
      <dd>{{ row.recipientUserId || '—' }}</dd>
      <dt>{{ 'adminNotifications.recipientEmail' | translate }}</dt>
      <dd>{{ row.recipientEmail || '—' }}</dd>
      <dt>{{ 'adminNotifications.channel' | translate }}</dt>
      <dd>{{ row.channelKey }}</dd>
      <dt>{{ 'adminNotifications.outcome' | translate }}</dt>
      <dd>{{ row.outcome }}</dd>
      <dt>{{ 'adminNotifications.reason' | translate }}</dt>
      <dd>{{ row.reason || '—' }}</dd>
      <dt>{{ 'adminNotifications.deepLink' | translate }}</dt>
      <dd>
        @if (row.deepLinkUrl) {
          <a [routerLink]="row.deepLinkUrl">{{ row.deepLink }}</a>
        } @else {
          {{ row.deepLink || '—' }}
        }
      </dd>
    </dl>
    <p><strong>{{ row.renderedTitle }}</strong></p>
    <div class="notification-rendered-body" [innerHTML]="row.renderedBody"></div>
  }
</p-dialog>
}

<ng-template #ruleForm>
    <div class="dialog-form">
      <msf-input [(model)]="ruleName" [label]="'adminNotifications.name' | translate"></msf-input>
      <div class="form-field">
        <div class="field-label">{{ 'adminNotifications.event' | translate }}</div>
        <msf-select
          [(model)]="ruleEventKey"
          [options]="events()"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'adminNotifications.event' | translate"
          translateBy="none"
          (modelChange)="onRuleEventChange($event)"
        ></msf-select>
      </div>
      @if (!lockedSourceProcess()) {
        <div class="form-field">
          <div class="field-label">{{ 'adminNotifications.sourceProcess' | translate }}</div>
          <msf-select
            [(model)]="ruleSourceProcessKey"
            [options]="processOptions()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'adminNotifications.anyProcess' | translate"
            translateBy="locale"
            (modelChange)="onSourceProcessChange($event)"
          ></msf-select>
        </div>
      }
      <div class="form-field">
        <div class="field-label">{{ 'adminNotifications.priority' | translate }}</div>
        <msf-select
          [(model)]="rulePriority"
          [options]="priorities"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'adminNotifications.priority' | translate"
          translateBy="none"
        ></msf-select>
      </div>
      @if (!lockedTemplate()) {
        <div class="form-field">
          <div class="field-label">{{ 'adminNotifications.template' | translate }}</div>
          <msf-select
            [(model)]="ruleTemplateId"
            [options]="templateOptions()"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'adminNotifications.template' | translate"
            translateBy="none"
          ></msf-select>
          <app-notification-template-fields [events]="templateFieldEvents()" [hideWhenEmpty]="true"></app-notification-template-fields>
        </div>
      }
      <div class="form-field">
        <div class="field-label">{{ 'adminNotifications.channels' | translate }}</div>
        <msf-multi-select
          [(model)]="ruleChannels"
          [options]="channelOptions()"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'adminNotifications.channel' | translate"
          translateBy="none"
        ></msf-multi-select>
      </div>
      <app-checkbox [(ngModel)]="ruleActive" label="adminNotifications.active"></app-checkbox>

      <h3>{{ 'adminNotifications.recipients' | translate }}</h3>
      @for (recipient of ruleRecipients; track $index) {
        <div class="recipient-row">
          <div class="form-field recipient-kind">
            <div class="field-label">{{ 'adminNotifications.recipientType' | translate }}</div>
            <msf-select
              [(model)]="recipient.kind"
              [options]="recipientKinds"
              optionLabel="label"
              optionValue="value"
              translateBy="locale"
            ></msf-select>
          </div>
          @if (recipient.kind === 'Email') {
            <msf-input [(model)]="recipient.emailAddress" [label]="'adminNotifications.emailAddress' | translate"></msf-input>
          } @else {
            <app-notification-recipient-picker
              [kind]="recipient.kind"
              [(entityId)]="recipient.entityId"
              [(roleName)]="recipient.roleName"
            ></app-notification-recipient-picker>
          }
          <app-secondary-button title="adminNotifications.remove" (action)="removeRecipient($index)"></app-secondary-button>
        </div>
      }
      <app-secondary-button title="adminNotifications.addRecipient" (action)="addRecipient()"></app-secondary-button>

      <h3>{{ 'adminNotifications.escalation' | translate }}</h3>
      @for (step of ruleEscalation; track $index) {
        <div class="escalation-block">
          <msf-input
            [(model)]="step.afterMinutes"
            type="number"
            [label]="'adminNotifications.afterMinutes' | translate"
          ></msf-input>
          <div class="form-field">
            <div class="field-label">{{ 'adminNotifications.channels' | translate }}</div>
            <msf-multi-select
              [(model)]="step.channelKeys"
              [options]="channelOptions()"
              optionLabel="label"
              optionValue="value"
              translateBy="none"
            ></msf-multi-select>
          </div>
          @for (recipient of step.recipients; track $index) {
            <div class="recipient-row">
              <div class="form-field recipient-kind">
                <div class="field-label">{{ 'adminNotifications.recipientType' | translate }}</div>
                <msf-select
                  [(model)]="recipient.kind"
                  [options]="recipientKinds"
                  optionLabel="label"
                  optionValue="value"
                  translateBy="locale"
                ></msf-select>
              </div>
              @if (recipient.kind === 'Email') {
                <msf-input [(model)]="recipient.emailAddress" [label]="'adminNotifications.emailAddress' | translate"></msf-input>
              } @else {
                <app-notification-recipient-picker
                  [kind]="recipient.kind"
                  [(entityId)]="recipient.entityId"
                  [(roleName)]="recipient.roleName"
                ></app-notification-recipient-picker>
              }
            </div>
          }
          <app-secondary-button title="adminNotifications.remove" (action)="removeEscalationStep($index)"></app-secondary-button>
        </div>
      }
      <app-secondary-button title="adminNotifications.addEscalation" (action)="addEscalationStep()"></app-secondary-button>
    </div>
</ng-template>

<p-dialog
  [visible]="editing()"
  (visibleChange)="closeEdit()"
  [header]="'Edit' | translate"
  [modal]="true"
  [style]="{ width: '46rem', maxWidth: '95vw' }"
>
  @if (editing()) {
    <ng-container *ngTemplateOutlet="ruleForm"></ng-container>
  }
  <ng-template #footer>
    <app-secondary-button title="Cancel" (action)="closeEdit()"></app-secondary-button>
    <app-primary-button title="Save" (action)="saveRule()"></app-primary-button>
  </ng-template>
</p-dialog>

<p-dialog
  [visible]="testing()"
  (visibleChange)="testing.set($event)"
  [header]="'adminNotifications.test' | translate"
  [modal]="true"
  [style]="{ width: '36rem', maxWidth: '95vw' }"
>
  <msf-input [(model)]="testUserId" [label]="'adminNotifications.testUserId' | translate"></msf-input>
  <ng-template #footer>
    <app-secondary-button title="Cancel" (action)="testing.set(false)"></app-secondary-button>
    <app-primary-button title="adminNotifications.test" (action)="testRule()"></app-primary-button>
  </ng-template>
</p-dialog>
